import React from "react";
import Hero from "../components/Hero";
import FeaturedWorkshops from "../components/FeaturedWorkshops";
import Gallery from "./Gallery";
import "./Home.css";
import Blog from "./Blog";
import About from "./About";
import Testimonials from "../components/Testimonials";
import CurvedAccent from "../assets/icone/CurvedAccent";

const Home: React.FC = () => {
  return (
    <div className="home-container">
      <div className="section-group">
        {/* <CurvedAccent className="curved-accent" /> */}
        <Hero />
        <FeaturedWorkshops />
        <Gallery />
      </div>

      <div className="section-group2">
        {/* <CurvedAccent className="curved-accent2" /> */}
        <Blog />
        <About />
        <Testimonials />
      </div>
    </div>
  );
};

export default Home;
